import React, { Component } from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';

class TimedOutErrorScreen extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { hasUserNameChosen, onReturnHome, onReturnLogin, clearError } = this.props;
    const handleReturnHome = () => {
      clearError && clearError();
      onReturnHome();
    };
    return (
      <>
        <PageHeading>{`Oops, your application has timed out`}</PageHeading>
        <StandardBody>
          {hasUserNameChosen ? (
            <>
              <p>{`Your application has timed out due to 30 minutes of inactivity. Don’t worry, all your details have been saved.`}</p>
              <p>{`Please login to pick up where you left off. All you need is your email address and mobile number.`}</p>
            </>
          ) : (
            <p>{`Your application has timed out due to 30 minutes of inactivity. You will need to restart your application.`}</p>
          )}
        </StandardBody>
        <NavigationButton.Primary
          labelText={hasUserNameChosen ? `Login` : `Restart application`}
          onClick={hasUserNameChosen ? onReturnLogin : handleReturnHome}
        />
      </>
    );
  }
}

export { TimedOutErrorScreen };
